import { Component } from '@angular/core';
import {IonicPage, NavController, NavParams, Platform, ViewController} from 'ionic-angular';
import { AuthProvider } from '../../../providers/auth/auth';
import { TBRProvider } from '../../../providers/tbr/tbr';
import { ProfilePage } from '../profile/profile';
import { SearchPage } from '../search/search';
import { Storage } from '@ionic/storage'


@IonicPage()
@Component({
  selector: 'page-quizz-list',
  templateUrl: 'quizz-list.html',
})
export class QuizzListPage {
  LOCAL:any = 'fr';
  questionList:any = [];
  answerList:any = [];
  initialQuestionCount = 0;


    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public tbrProvider: TBRProvider,
                private authProvider: AuthProvider,
                public storageProvider: Storage,
                platform: Platform,
                private viewCtrl: ViewController) {
      platform.ready().then(() => {
        this.storageProvider.get('LOCAL').then(local => {
          if(local){
            this.LOCAL = local;
          }
        })
      })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad QuizzListPage');
  }

  ngOnInit() {
    this.tbrProvider.getQuestions().subscribe((res) => {
      if(res.success){
        this.questionList = res.data;
        this.initialQuestionCount = this.questionList.length;
      }
    })
  }

  setAnswer(questionId, answer, i){
    if(answer == null){
      this.questionList.splice(i, 1);
      this.initialQuestionCount--;
    }else{
      this.answerList.push([questionId, answer]);
      this.questionList.splice(i, 1);
    }
  }

  submitAnswers(){
    this.tbrProvider.saveQuestions({answers : this.answerList}).subscribe((res) => {
      if(res.success){
        this.navCtrl.pop();
      }
    })
  }

  leaveWindow(){
    this.navCtrl.pop();
  }


  goToSearch() {
    this.navCtrl.push(SearchPage, {})
      .then(() => {
        console.log('Welcome to search');
      })
  }

  getNameFromLocal(object, key){
    if(object !== null){
        if(this.LOCAL == 'fr'){
          return object[key]
        }else{
          return object[key+'_'+this.LOCAL]
        }
      }
    }

    dismiss() {
      this.viewCtrl.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/pages/employee/quizz-list/quizz-list.ts